module.exports = __webpack_public_path__ + "static/media/keyboard_light.bf7fffb6.svg";